module.exports = {
    darkBlue: '#239FFC',
    blue: '#C4CAE3',
    'blue-2': '#44AFF6',
    'blue-3': '#e6f4ff',
    'blue-4': '#E7E8F2',
    'blue-5': '#EDEFFC',
    'blue-6': '#4996ff',
    'blue-8': '#007BFF14',
    'blue-10': '#007BFF0A',
    lightBlue: '#F3F5FF',
    white: '#FFFFFF',
    primary: {
        0: '#ffffff',
        10: '#fff4ef',
        20: '#ffe4d6',
        30: '#ffd1c0',
        40: '#ffbfa5',
        50: '#ffb59a',
        60: '#b7754a',
        70: '#7f523b',
        80: '#513a2b',
        90: '#37251a',
        100: '#000000',
        light: '#3949e4',
        hover: '#3d4bc2',
        container: '#c7c6f9',
        'container-hover': '#e0e0ff',
        'on-container': '#f1f0ff',
        on: '#ffffff',
        main: '#233AC6',
        red: '#FF3838'
    },
    secondary: '#00042E',
    'theme-dark': '#00042E',
    transparent: 'transparent',
    gray: '#757A8D',
    'gray-2': '#C4CAE3',
    'gray-3': '#535353',
    'gray-4': '#5F6374',
    'gray-5': '#E5E5E5',
    'gray-6': '#F4F4F4',
    'gray-7': '#F5F7F9',
    'gray-8': '#757779',
    'gray-9': '#737373',
    'gray-border': '#B4B8C7',
    darkerBlue: '#3985C0',
    greenish: '#62DBD3',
    'greenish-2': '#44AFF6',
    info: '#239FFC',
    infoHover: '#3985C0',
    red: '#D10000',
    label: '#757A8D',
    'blue-500': '#239FFC',
    'blue-100': '#F3F5FF',
    midnightBlue: '#41508A',
    'shadow-xl': 'rgba(65, 80, 138, 0.10)',
    disabled: '#F3F5FF',
    disabledBorder: 'rgba(117, 122, 141, 0.20)',
    shadow: 'rgba(65, 80, 138, 0.10)',
    border: 'rgba(117, 122, 141, 0.3)',
    lightBorder: '#0505050f',
    warning: '#EFA536',
    success: '#43BA7A',
    'success-200': '#27B087',
    error: '#D10000',
    lavender: '#C9CFF5',
    noir: '#191C1E',
    // Primary
    'on-primary-container-light': '#f1f0ff',
    'primary-container-hover-light': '#e0e0ff',
    'primary-container-light': '#c7c6f9',
    'on-primary-light': '#ffffff',
    'primary-hover-light': '#3d4bc2',
    'primary-light': '#3949e4',
    // Background and Surface
    'on-surface-light': '#1c1b1f',
    'surface-light': '#ffffff',
    'on-background-light': '#1c1b1f',
    'background-light': '#f5f5fa',
    'on-background': '#191C1E',
    // Notifications
    'error-container-light': '#f9dedc',
    'error-light': '#b3261e',
    'error-hover-light': '#d32f2f',
    'on-error-light': '#ffffff',
    'warning-container-light': '#fff8e1',
    'warning-light': '#efa536',
    'warning-hover-light': '#ffb300',
    'info-container-light': '#e6f0fa',
    'info-hover-light': '#1565c0',
    'info-light': '#239ffc',
    'success-container-light': '#e6f9ef',
    'success-hover-light': '#43ba7a',
    'success-light': '#50a060',
    // Primary Palette
    'primary-100': '#000000',
    'primary-90': '#37251a',
    'primary-80': '#513a2b',
    'primary-70': '#7f523b',
    'primary-60': '#b7754a',
    'primary-50': '#ffb59a',
    'primary-40': '#ffbfa5',
    'primary-30': '#ffd1c0',
    'primary-20': '#ffe4d6',
    'primary-10': '#fff4ef',
    'primary-0': '#ffffff',
    // Neutral
    neutral: {
        0: '#ffffff',
        3: '#E8ECEF',
        4: '#EBEDEF',
        6: '#6C7275',
        7: '#141718',
        10: '#f9f9f9',
        20: '#f5f5fa',
        30: '#e1e2e6',
        40: '#c5c7cb',
        50: '#a8a8ac',
        60: '#757579',
        70: '#575757',
        80: '#373737',
        90: '#1c1b1f',
        100: '#000000',
    },
    // Red
    red: {
        10: '#f9dedc',
        20: '#FFE8E5',
        40: '#b3261e',
        50: '#d32f2f',
        70: '#E51900',
        100: '#FD5B2C',
        light: '#F23218'
    },
    // Yellow
    yellow: {
        10: '#fff8e1',
        40: '#efa536',
        50: '#ffb300',
    },
    // Blue
    blue: {
        10: '#e6f0fa',
        40: '#1565c0',
        50: '#239ffc',
    },
    // Green
    green: {
        10: '#E5FFF1',
        30: '#16D29A',
        40: '#43ba7a',
        50: '#50a060',
        60: '#00AB50',
        70: '#00873F',
        100: '#3F7933'
    },
    black: {
        2: '#2B2B2B',
        4: '#4C4C4C14',
        8: '#4C4C4C24',
        10: '#0000000f',
        12: '#4C4C4C1F',
        14: '#00000014',
        48: '#4C4C4C7A',
        100: '#4C4C4C',
        200: '#EAEAEA',
        900: '#121212'
    },
    orange: {
        4: '#F291000A',
        8: '#F2910014',

        100: '#F29100',
    },
    'gray-opacity': '#4C4C4C52',
    pastelBlue: '#E9F1FC',
}; 